import addMaster from "app/api/requests/Master/addMasterRequest";
import delMaster from "app/api/requests/Master/delMasterRequest";
import editMaster from "app/api/requests/Master/editMasterRequest";
import getMasters from "app/api/requests/Master/getMastersRequest";
import uploadMasterImg from "app/api/requests/Master/uploadMasterImgRequest";
import uploadMasterDiploma from "app/api/requests/Master/uploadMasterDiplomaRequest";
import deleteMasterDiploma from "app/api/requests/Master/deleteMasterDiplomaRequest";

export default {
  addMaster,
  delMaster,
  editMaster,
  getMasters,
  uploadMasterImg,
  uploadMasterDiploma,
  deleteMasterDiploma
};
